<div class="card">
    <p-menubar [model]="menu">
        <ng-template pTemplate="end">
          <p-menu #menu [model]="menuUser" [popup]="true" />
          <button pButton (click)="menu.toggle($event)" class="p-button" [text]="true" pTooltip="Menú Usuario">
            <i class="pi pi-user text-gray-500"></i>
            <i class="pi pi-angle-down text-gray-500"></i>
          </button>
        </ng-template>
    </p-menubar>
</div>
